import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import VueLazyload from 'vue-lazyload'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import '@/assets/css/common.css'

import axios from 'axios'
Vue.prototype.$axios = axios
import '@/assets/iconfont/iconfont.js'

Vue.prototype.$EventBus = new Vue()

import i18n from './i18n'

import store from './store'

Vue.use(ElementUI)
import './assets/icons/index'
Vue.use(VueLazyload, {
	preLoad: 1,
	loading: require('./assets/img/other/loading.jpg'),
	attempt: 5,
})
import Msg from '../src/components/message' // 引入message.js暴露出来的方法
Vue.use(Msg)

// 注册全局自定义指令 `v-real-img`
//  检测图片是否存在
const imageIsExist = function (url) {
	return new Promise((resolve) => {
		let img = new Image()
		img.onload = function () {
			if (this.complete === true) {
				resolve(true)
				img = null
			}
		}

		img.onerror = function () {
			resolve(false)
			img = null
		}

		img.src = url
	})
}
Vue.directive('real-img', {
	async inserted(el, binding) {
		let imgUrl = binding.value
		if (imgUrl) {
			let exist = await imageIsExist(imgUrl)
			if (exist) {
				el.setAttribute('src', imgUrl)
			}
		}
	},
})
Vue.config.productionTip = false
new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('#app')
